// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btnBox[data-v-ec605d98] {\n  margin: 100px 0;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.copywritingItem[data-v-ec605d98] {\n  position: relative;\n}\n.copywritingItem .desBox[data-v-ec605d98] {\n  position: absolute;\n  right: -100px;\n  top: 0;\n}", ""]);
// Exports
module.exports = exports;
